const VersionInfo = {
    version: "2.9.0",
    major: 2,
    minor: 9,
    patch: 0,
    suffix: "",
    isNext: false,
    buildTime: 1743779257,
};
export default VersionInfo;
//# sourceMappingURL=VersionInfo.js.map